import React, {useContext} from "react";
import Section from "../../Section/Section";
import Overview from "./Overview";
import FormStepSizes from "./FormStepSizes";
import FormStepHeaters from "./FormStepHeaters";
import FormStepAccessories from "./FormStepAccessories";
import FormStepInteriorExterior from "./FormStepInteriorExterior";
import SidebarContainer from "../../SidebarContainer/SidebarContainer";
import {ConfigurationContext} from "./ConfigurationContext";
import {isSubmitDisabled} from "./utils";
import {useSubmitQuote} from "../../../hooks/useSubmitQuote";


const Sidebar = ({sections}) => {
    const {size, heaters, interiorexterior, accessories, totalPrice} =
        useContext(ConfigurationContext);
    const { submitFormQuote, mapArrayToString, mapItemToString, mapItemsForZapier } = useSubmitQuote();

    const handleAddToCart = async ({name, phone, email, postCode, sendLink, reference, timescale, screenShot}) => {
        const coCartData = {
            id: "148",
            quantity: "1",
            item_data: {
                nyp: totalPrice,
                custom_data: {
                    Size: mapItemToString(size),
                    Heater: mapItemToString(heaters.heater),
                    Upgrades: mapArrayToString(heaters.upgrades),
                    Wood: mapItemToString(interiorexterior.wood),
                    "Wood Treatment": mapArrayToString(interiorexterior.woodTreatment),
                    "Liner Colour": mapItemToString(interiorexterior.linerColor),
                    "Liner Type": mapItemToString(interiorexterior.linerType),
                    Lid: mapItemToString(accessories.lidCover),
                    "Flue / Drain Add-ons": mapArrayToString(accessories.flueDrain),
                    "Electrical Add-ons": mapArrayToString(accessories.electrical),
                    "Wooden Add-ons": mapArrayToString(accessories.wooden),
                    "Water Care Add-ons": mapArrayToString(accessories.waterCare),
                },
            },
        };

        const zapierData = {
            name,
            phone,
            email,
            "Total price": `${totalPrice}`,
            "Image hash": screenShot,
            "Post code": postCode,
            "Send emails": sendLink,
            "Reference": reference,
            "Timescale": timescale,
            Size: mapItemsForZapier(size),
            Heater: mapItemsForZapier(heaters.heater),
            Upgrades: mapItemsForZapier(heaters.upgrades),
            Wood: mapItemsForZapier(interiorexterior.wood),
            "Wood Treatment": mapItemsForZapier(interiorexterior.woodTreatment),
            "Liner Colour": mapItemsForZapier(interiorexterior.linerColor),
            "Liner Type": mapItemsForZapier(interiorexterior.linerType),
            Lid: mapItemsForZapier(accessories.lidCover),
            "Flue / Drain Add-ons": mapItemsForZapier(accessories.flueDrain),
            "Electrical Add-ons": mapItemsForZapier(accessories.electrical),
            "Wooden Add-ons": mapItemsForZapier(accessories.wooden),
            "Water Care Add-ons": mapItemsForZapier(accessories.waterCare),
        }

        return await submitFormQuote({coCartData, size, totalPrice, zapierData}, 'deluxe')
    };

    return (
        <SidebarContainer
            sections={sections}
            totalPrice={totalPrice}
            title={`${size?.label} Hot Tub`}
            isSubmitDisabled={isSubmitDisabled(size, heaters, interiorexterior, accessories)}
            onAddToCart={handleAddToCart}
            name='deluxeFormStep'
        >
            {(activeSection, setActiveSection) => [
                <Section
                    key={0}
                    index={0}
                    open={activeSection === 0}
                    filled={activeSection > 0}
                    setActiveSection={setActiveSection}
                    title={sections[0].title}
                    description={sections[0].description}
                    changedField={size}
                >
                    <FormStepSizes
                        sizeField={sections[0].fields.size}

                    />
                </Section>,
                <Section
                    key={1}
                    index={1}
                    open={activeSection === 1}
                    filled={activeSection > 1}
                    setActiveSection={setActiveSection}
                    title={sections[1].title}
                    description={sections[1].description}
                    changedField={interiorexterior}
                >
                    <FormStepInteriorExterior
                        woodField={sections[1].fields.wood}
                        woodTreatmentField={sections[1].fields.woodTreatment}
                        heaterField={sections[2].fields.heater}
                        electricalField={sections[3].fields.electrical}
                        linerColorField={sections[1].fields.linerColor}
                        linerTypeField={sections[1].fields.linerType}
                    />
                </Section>,
                <Section
                    key={2}
                    index={2}
                    open={activeSection === 2}
                    filled={activeSection > 2}
                    setActiveSection={setActiveSection}
                    title={sections[2].title}
                    description={sections[2].description}
                    changedField={heaters}
                >
                    <FormStepHeaters
                        heaterField={sections[2].fields.heater}
                        upgradesField={sections[2].fields.upgrades}
                    />
                </Section>,
                <Section
                    key={3}
                    index={3}
                    open={activeSection === 3}
                    filled={activeSection > 3}
                    setActiveSection={setActiveSection}
                    title={sections[3].title}
                    description={sections[3].description}
                    changedField={accessories}
                >
                    <FormStepAccessories
                        lidCoverField={sections[3].fields.lidCover}
                        flueDrainField={sections[3].fields.flueDrain}
                        electricalField={sections[3].fields.electrical}
                        woodenField={sections[3].fields.wooden}
                        waterCareField={sections[3].fields.waterCare}
                    />
                </Section>,
                <Section
                    key={sections.length}
                    index={sections.length}
                    open={activeSection === sections.length}
                    title="Overview"
                >
                    <Overview
                        size={size}
                        heaters={heaters}
                        interiorexterior={interiorexterior}
                        accessories={accessories}
                        totalPrice={totalPrice}
                    />
                </Section>,
            ]}
        </SidebarContainer>
    );
};

export default Sidebar;
